<section width="100%">
  <div class="loader">
    <img
      width="70"
      height="70"
      loading="lazy"
      class="img-fluid"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/loading-rdo.gif"
      alt="Carregando"
    />
  </div>
</section>
